import { ColumnHeaderRowType } from "components/atoms/ExpandedRowTable/ExpandedRowTable";

export const ROLE_MANAGEMENT_COLUMN_DATA: Array<ColumnHeaderRowType> = [
	{
		title: "Date & Time Created",
		dataIndex: "created_on",
		align: "left",
		width: "10%"
	},
	{
		title: "Groups",
		dataIndex: "groups",
		align: "left"
	},
	{
		title: "2FA Enabled",
		dataIndex: "mfa_enabled",
		align: "left",
		width: "9%"
	},
	{
		title: "UserName",
		dataIndex: "username",
		align: "left",
		width: "12%"
	},
	{
		title: "First Name",
		dataIndex: "first_name",
		align: "left",
		width: "10%"
	},
	{
		title: "Last Name",
		dataIndex: "last_name",
		align: "left",
		width: "10%"
	},
	{
		title: "Email Address",
		dataIndex: "email",
		align: "left",
		width: "18%"
	},
	{
		title: "Status",
		dataIndex: "active",
		align: "left",
		width: "9%"
	},
	{
		title: "View/Edit",
		dataIndex: "viewOrEdit",
		align: "center",
		width: "8%"
	}
];
